import { putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const UPDATE_CAMPAIGN_STATUS = 'UPDATE_CAMPAIGN_STATUS';
export const UPDATE_CAMPAIGN_STATUS_SUCCESS = 'UPDATE_CAMPAIGN_STATUS_SUCCESS';
export const UPDATE_CAMPAIGN_STATUS_FAILURE = 'UPDATE_CAMPAIGN_STATUS_FAILURE';

// Action Creators
export const fetchUpdateCampaignStatus = () => ({
  type: UPDATE_CAMPAIGN_STATUS,
});

export const fetchUpdateCampaignStatusSuccess = (data) => ({
  type: UPDATE_CAMPAIGN_STATUS_SUCCESS,
  payload: data,
});

export const fetchUpdateCampaignStatusFailure = (error) => ({
  type: UPDATE_CAMPAIGN_STATUS_FAILURE,
  payload: error,
});

// Thunk Function
export const updateCampaignStatusCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchUpdateCampaignStatus(data, external));
    try {
      const response = await putMethodWithToken(
        url.updateCampaignStatusSuperAdmin,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchUpdateCampaignStatusSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchUpdateCampaignStatusFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchUpdateCampaignStatusFailure(error.message));
    }
  };
};
